/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function DataEntryLinkActionsRepresentationFromJSON(json) {
    return DataEntryLinkActionsRepresentationFromJSONTyped(json, false);
}
export function DataEntryLinkActionsRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        canCreate: json['canCreate'],
        canDelete: json['canDelete'],
        canGet: json['canGet'],
        canUpdate: json['canUpdate'],
    };
}
export function DataEntryLinkActionsRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        canCreate: value.canCreate,
        canDelete: value.canDelete,
        canGet: value.canGet,
        canUpdate: value.canUpdate,
    };
}
